// Firebase init + the thin wrappers every module shares. Kept in one place so
// App.js and future feature modules import `db` / `auth` / `LS` from here
// instead of re-deriving them.
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, collection, doc } from "firebase/firestore";
import { getMessaging, isSupported as isMessagingSupported } from "firebase/messaging";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBKTl_JMskxzzPbYNwaR36dVfu8WRsbIBA",
  authDomain: "ufcm-app.firebaseapp.com",
  projectId: "ufcm-app",
  storageBucket: "ufcm-app.firebasestorage.app",
  messagingSenderId: "335318245063",
  appId: "1:335318245063:web:0ac1339e8f234963a728e2",
  measurementId: "G-PN3BDLVW82"
};
const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = initializeFirestore(firebaseApp, {
  ignoreUndefinedProperties: true, // drop undefined fields instead of throwing on setDoc/addDoc
  cache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});
export const googleProvider = new GoogleAuthProvider();

// Bearer header for calls to our own /api/* — the server derives the user from
// this token (never from a body field).
export const authHeader = async () => {
  try { const t = await auth.currentUser?.getIdToken(); return t ? { Authorization: `Bearer ${t}` } : {}; }
  catch { return {}; }
};

// Firebase Analytics — web only, not the Android WebView.
export let analytics = null;
export const isWebPlatform = !window.Capacitor?.isNativePlatform?.();
if (isWebPlatform) {
  try { analytics = getAnalytics(firebaseApp); } catch (e) {}
}
export const track = (event, params = {}) => {
  try { if (analytics) logEvent(analytics, event, params); } catch (e) {}
};

// FCM Messaging (web push). isSupported() must gate getMessaging() or it throws
// an unhandled rejection every launch in the Android WebView / unsupported
// browsers (which use native FCM anyway). Live binding — importers read it after
// the async assignment lands.
export let messaging = null;
isMessagingSupported()
  .then((ok) => { if (ok) { try { messaging = getMessaging(firebaseApp); } catch (e) {} } })
  .catch(() => {});

// FCM VAPID Key — Firebase Console → Project Settings → Cloud Messaging → Web Push certificates
export const FCM_VAPID_KEY = "YOUR_VAPID_KEY_HERE";

// Each user's data lives at users/{uid}/{collection}
export const userCol = (uid, col) => collection(db, "users", uid, col);
export const userMeta = (uid) => doc(db, "users", uid, "meta", "profile");

export const LS = {
  get: (k) => { try { return JSON.parse(localStorage.getItem(k)) } catch { return null } },
  set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)) } catch {} },
};
